import Keycloak from "keycloak-js";
import { config } from "./runtimeConfig";

// `ethosphere-client` is a PUBLIC Keycloak client (publicClient: true,
// serviceAccountsEnabled: false), so the OAuth client secret that used to be
// shipped here was inert — it has no effect on the public auth-code flow and
// only leaked into the JS bundle. We drop it and rely on PKCE (S256) instead;
// see the `pkceMethod` in the ReactKeycloakProvider initOptions (src/index.js).
const keycloakConfig = new Keycloak({
  url: config.KEYCLOAK_URL,
  realm: config.KEYCLOAK_REALM,
  clientId: config.KEYCLOAK_CLIENT_ID,
});

export default keycloakConfig;
